import { render, staticRenderFns } from "./VisaReportToLive.vue?vue&type=template&id=74b9ea17"
import script from "./VisaReportToLive.vue?vue&type=script&lang=js"
export * from "./VisaReportToLive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports